'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var shape = {};

exports.__exports = shape;
